import { useEffect, useState, useCallback } from 'react'

import AddFeedback from '../../Components/Feedbacks/addFeedback'
import { FeedbackTable } from '../../Components/Feedbacks/feedbackTable'

import Feedback from '../../API/Employee/Feedback'
import Loading from '../../Components/Loading/Loading'

import Swal from 'sweetalert2'

export function FeedbacksEmployee() {
	const { id } = JSON.parse(localStorage.getItem('user'))
	const [data, setData] = useState(null)

	const loadData = useCallback(async () => {
		try {
			const response = await Feedback.getAllSendFeedbacks(id)
			setData(response.data)
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	if (!data) return <Loading />

	return (
		<>
			<div className='tw-flex tw-justify-between tw-items-start tw-ml-16 2xl:tw-ml-10 22xl:tw-ml-0 tw-mr-6 2xl:tw-mr-16  tw-text-sm 2xl:tw-text-base'>
				<div className='tw-max-w-3xl tw-mr-5 tw-font-bold tw-text-2xl tw-mb-4'>Feedbacks Enviados</div>

				<div className='div'>
					<AddFeedback load={loadData} />
				</div>
			</div>

			<div className='tw-mt-5 tw-ml-10 tw-mr-16 tw-min-h-full'>
				{data.length === 0 ? (
					<div className='tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-gray-100 tw-p-4 tw-space-y-5 tw-h-[75vh]'>
						<div className='tw-font-bold tw-text-xl'>No has enviado ningún feedback todavia.</div>
						<AddFeedback />
					</div>
				) : (
					<FeedbackTable data={data} />
				)}
			</div>
		</>
	)
}
